export const OUTSTANDING_BREAKDOWN_OPTIONS = Object.freeze({
  UP_TO_ONE_MONTH: 'upToOneMonth',
  ONE_TO_TWO_MONTHS: 'oneToTwoMonths',
  TWO_TO_THREE_MONTHS: 'twoToThreeMonths',
  MORE_THAN_THREE_MONTHS: 'moreThanThreeMonths',
});

export type OutstandingBreakdownOptions = typeof OUTSTANDING_BREAKDOWN_OPTIONS[keyof typeof OUTSTANDING_BREAKDOWN_OPTIONS];